import styled from 'styled-components';

export const StyledCustomWorkflows = styled.div`
  .shopify-flow-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    background-color: #e0f0ff;
    border-radius: 0.5rem;
    color: #00527c;
    font-size: 0.75rem;
    font-weight: 500;
  }
`;
